(() => {
  var returningContentData = {
    bodyShield: {
      "100cm": {
        options: {
          option1: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 100 cm (no face hole)", subtitle: "(3 rolls of 30 units)", price: "$145.20" },
              { name: "PillowGuard Recyclable", subtitle: "(2 boxes of 25 units)", price: "$57.20" }
            ],
            totalRRP:    "$202.40",
            bundlePrice: "$182.16",
            savings:     "$20.24 (approx. $2.03 per client)",
            link: "https://purifas.myshopify.com/cart/42310869024919:3,41713821778071:2?discount=Therapy+Bed+Solution+100cm+S"
          },
          option2: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 100 cm (no face hole)", subtitle: "(6 rolls of 30 units)", price: "$290.40" },
              { name: "PillowGuard Recyclable", subtitle: "(4 boxes of 25 units)", price: "$114.40" }
            ],
            totalRRP:    "$404.80",
            bundlePrice: "$323.84",
            savings:     "$80.96 (approx. $1.79 per client)",
            link: "https://purifas.myshopify.com/cart/42310869024919:6,41713821778071:4?discount=Therapy+Bed+Solution+100cm+M"
          },
          option3: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 100 cm", subtitle: "(30 rolls of 30 units)", price: "$1,452.00" },
              { name: "PillowGuard Recyclable", subtitle: "(18 boxes of 25 units)", price: "$514.80" }
            ],
            totalRRP:    "$1,966.80",
            bundlePrice: "$1,376.76",
            savings:     "$590.04 (approx. $1.53 per client)",
            link: "https://purifas.myshopify.com/cart/42310869024919:30,41713821778071:18?discount=Therapy+Bed+Solution+100cm+L"
          }
        }
      },
      "72cm": {
        options: {
          option1: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 72 cm (no face hole)", subtitle: "(3 rolls of 30 units)", price: "$99.00" },
              { name: "PillowGuard Recyclable", subtitle: "(2 boxes of 25 units)", price: "$57.20" }
            ],
            totalRRP:    "$156.20",
            bundlePrice: "$140.58",
            savings:     "$15.62 (approx. $1.57 per client)",
            link: "https://purifas.myshopify.com/cart/42310870859927:3,41713821778071:2?discount=Therapy+Bed+Solution+72cm+S"
          },
          option2: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 72 cm (no face hole)", subtitle: "(9 rolls of 30 units)", price: "$297.00" },
              { name: "PillowGuard Recyclable", subtitle: "(5 boxes of 25 units)", price: "$143.00" }
            ],
            totalRRP:    "$440.00",
            bundlePrice: "$352.00",
            savings:     "$88.00 (approx. $1.30 per client)",
            link: "https://purifas.myshopify.com/cart/42310870859927:9,41713821778071:5?discount=Therapy+Bed+Solution+72cm+M"
          },
          option3: {
            productName: "Therapy Bed Solution",
            tableRows: [
              { name: "BodyShield 72 cm (no face hole)", subtitle: "(30 rolls of 30 units)", price: "$990.00" },
              { name: "PillowGuard Recyclable", subtitle: "(18 boxes of 25 units)", price: "$514.80" }
            ],
            totalRRP:    "$1,504.80",
            bundlePrice: "$1,053.36",
            savings:     "$451.44 (approx. $1.17 per client)",
            link: "https://purifas.myshopify.com/cart/42310870859927:30,41713821778071:18?discount=Therapy+Bed+Solution+72cm+L"
          }
        }
      }
    },
    faceShield: {
      "default": {
        options: {
          option1: {
            productName: "Face Hole Solution",
            tableRows: [
              { name: "FaceShield", subtitle: "(8 boxes of 100 units)", price: "$316.80" }
            ],
            totalRRP:    "$316.80",
            bundlePrice: "$300.96",
            savings:     "$15.84 (approx. $0.37 per client)",
            link: "https://purifas.myshopify.com/cart/26814001119296:8?discount=Face+Hole+Solution+S"
          },
          option2: {
            productName: "Face Hole Solution",
            tableRows: [
              { name: "FaceShield", subtitle: "(40 boxes of 100 units)", price: "$1,584.00" }
            ],
            totalRRP:    "$1,584.00",
            bundlePrice: "$1,425.60",
            savings:     "$158.40 (approx. $0.35 per client)",
            link: "https://purifas.myshopify.com/cart/26814001119296:40?discount=Face+Hole+Solution+L"
          }
        }
      }
    },
    ultimateSystem: {
      "100cm": {
        options: {
          option1: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 100 cm (with face hole)", subtitle: "(3 rolls of 30 units)", price: "$145.20" },
              { name: "PillowGuard Recyclable", subtitle: "(2 boxes of 25 units)", price: "$57.20" },
              { name: "FaceShield", subtitle: "(1 box of 100 units)", price: "$39.60" }
            ],
            totalRRP:    "$242.00",
            bundlePrice: "$217.80",
            savings:     "$24.20 (approx. $2.42 per client)",
            link: "https://purifas.myshopify.com/cart/41669865930903:3,41713821778071:2,26814001119296:1?discount=Ultimate+Solution+100cm+S"
          },
          option2: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 100 cm (with face hole)", subtitle: "(6 rolls of 30 units)", price: "$290.40" },
              { name: "PillowGuard Recyclable", subtitle: "(4 boxes of 25 units)", price: "$114.40" },
              { name: "FaceShield", subtitle: "(2 boxes of 100 units)", price: "$79.20" }
            ],
            totalRRP:    "$483.60",
            bundlePrice: "$386.88",
            savings:     "$97.12 (approx. $2.14 per client)",
            link: "https://purifas.myshopify.com/cart/41669865930903:6,41713821778071:4,26814001119296:2?discount=Ultimate+Solution+100cm+M"
          },
          option3: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 100 cm (with face hole)", subtitle: "(30 rolls of 30 units)", price: "$1,452.00" },
              { name: "PillowGuard Recyclable", subtitle: "(18 boxes of 25 units)", price: "$514.80" },
              { name: "FaceShield", subtitle: "(9 boxes of 100 units)", price: "$356.40" }
            ],
            totalRRP:    "$2,323.20",
            bundlePrice: "$1,626.24",
            savings:     "$696.96 (approx. $1.81 per client)",
            link: "https://purifas.myshopify.com/cart/41669865930903:30,41713821778071:18,26814001119296:9?discount=Ultimate+Solution+100cm+L"
          }
        }
      },
      "72cm": {
        options: {
          option1: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 72 cm (with face hole)", subtitle: "(3 rolls of 30 units)", price: "$99.00" },
              { name: "PillowGuard Recyclable", subtitle: "(2 boxes of 25 units)", price: "$57.20" },
              { name: "FaceShield", subtitle: "(1 box of 100 units)", price: "$39.60" }
            ],
            totalRRP:    "$195.80",
            bundlePrice: "$176.22",
            savings:     "$19.58 (approx. $1.96 per client)",
            link: "https://purifas.myshopify.com/cart/41712761569431:3,41713821778071:2,26814001119296:1?discount=Ultimate+Solution+72cm+S"
          },
          option2: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 72 cm (with face hole)", subtitle: "(9 rolls of 30 units)", price: "$297.00" },
              { name: "PillowGuard Recyclable", subtitle: "(5 boxes of 25 units)", price: "$143.00" },
              { name: "FaceShield", subtitle: "(3 boxes of 100 units)", price: "$118.80" }
            ],
            totalRRP:    "$558.80",
            bundlePrice: "$447.04",
            savings:     "$111.76 (approx. $1.65 per client)",
            link: "https://purifas.myshopify.com/cart/41712761569431:9,41713821778071:5,26814001119296:3?discount=Ultimate+Solution+72cm+M"
          },
          option3: {
            productName: "Ultimate Solution",
            tableRows: [
              { name: "BodyShield 72 cm (with face hole)", subtitle: "(30 rolls of 30 units)", price: "$990.00" },
              { name: "PillowGuard Recyclable", subtitle: "(18 boxes of 25 units)", price: "$514.80" },
              { name: "FaceShield", subtitle: "(9 boxes of 100 units)", price: "$356.40" }
            ],
            totalRRP:    "$1,861.20",
            bundlePrice: "$1,302.84",
            savings:     "$558.36 (approx. $1.45 per client)",
            link: "https://purifas.myshopify.com/cart/41712761569431:30,41713821778071:18,26814001119296:9?discount=Ultimate+Solution+72cm+L"
          }
        }
      }
    }
  };
  
  // Restore if we have something
  const saved = readState();
  if (Object.keys(saved).length) applyState(saved);
  
  function updateReturningContent(selectedSize, systemType, selectedOption) {
    var contentDataObj;
    if (systemType === 'faceShield') {
      contentDataObj = returningContentData[systemType]["default"].options[selectedOption];
    } else {
      if (!returningContentData[systemType] || !returningContentData[systemType][selectedSize]) {
        selectedSize = Object.keys(returningContentData[systemType])[0];
        if (!selectedSize) return;
      }
      contentDataObj = returningContentData[systemType][selectedSize].options[selectedOption];
    }
    var solutionContainer = document.querySelector('.solution-container[data-system="'+systemType+'"]');
    if (!solutionContainer || !contentDataObj) return;
    var top = solutionContainer.querySelector('.pricing-column-top');
    var bottom = solutionContainer.querySelector('.pricing-column-bottom');
    var titleEl = top.querySelector('.title-section h2');
    if (titleEl) titleEl.textContent = contentDataObj.productName;
    var selectWrap = top.querySelector('.select-wrapper');
    if (selectWrap) {
      selectWrap.querySelector('.rrp-price-value').textContent      = contentDataObj.totalRRP;
      selectWrap.querySelector('.purchase-price-value').textContent = contentDataObj.bundlePrice;
      selectWrap.querySelector('.top-savings').textContent          = contentDataObj.savings;
      selectWrap.querySelector('.action_button[data-button="select"]').href = contentDataObj.link;
    }
    var tbody = bottom.querySelector('table tbody');
    if (tbody) {
      tbody.innerHTML = '';
      contentDataObj.tableRows.forEach(function(row) {
        var tr = document.createElement('tr');
        var td1 = document.createElement('td');
        td1.appendChild(document.createTextNode(row.name));
        if (row.subtitle) {
          var sp = document.createElement('span');
          sp.className = 'subtitle';
          sp.textContent = row.subtitle;
          td1.appendChild(sp);
        }
        var td2 = document.createElement('td');
        td2.textContent = row.price;
        tr.appendChild(td1);
        tr.appendChild(td2);
        tbody.appendChild(tr);
      });
      bottom.querySelector('.total-rrp').textContent = contentDataObj.totalRRP;
    }
  }
  
  ['bodyShield','faceShield','ultimateSystem'].forEach(function(systemType) {
    var cont = document.querySelector('.solution-container[data-system="'+systemType+'"]');
    if (!cont) return;
    var top = cont.querySelector('.pricing-column-top');
    var size = (systemType!=='faceShield' && top.querySelector('.fs-toggle-input').checked) ? '100cm' : '72cm';
    var opt  = top.querySelector('.bundle-size-selector input:checked').value;
  
    updateReturningContent(size, systemType, opt);
  });
  
  document.querySelectorAll('.fs-toggle-input').forEach(function(toggle) {
    toggle.addEventListener('change', function() {
      var cont = this.closest('.solution-container');
      var type = cont.getAttribute('data-system');
      var size = this.checked ? '100cm' : '72cm';
      var opt  = cont.querySelector('.bundle-size-selector input:checked').value;
      updateReturningContent(size, type, opt);
      ['bodyShield','ultimateSystem'].filter(s=>s!==type).forEach(function(other) {
        var ocont = document.querySelector('.solution-container[data-system="'+other+'"]');
        var ot   = ocont.querySelector('.fs-toggle-input');
        ot.checked = this.checked;
        var oo   = ocont.querySelector('.bundle-size-selector input:checked').value;
        updateReturningContent(size, other, oo);
      }, this);
  
      persist();
    });
  });
  document.querySelectorAll('.bundle-size-selector input').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var cont = this.closest('.solution-container');
      var type = cont.getAttribute('data-system');
      var size = (type!=='faceShield' && cont.querySelector('.fs-toggle-input').checked) ? '100cm' : '72cm';
      updateReturningContent(size, type, this.value);
      persist();
    });
  });
  
  document.querySelectorAll('.action_button.continue-button').forEach(el => el.addEventListener('click', persist));
  
  function readState() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeState(state) {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  
  function getCurrentState() {
    const state = {};
    ['bodyShield','faceShield','ultimateSystem'].forEach(type => {
      const cont = document.querySelector(`.solution-container[data-system="${type}"]`);
      if (!cont) return;
      const opt = cont.querySelector('.bundle-size-selector input:checked')?.value;
      if (!opt) return;
      state[type] = { option: opt };
      if (type !== 'faceShield') {
        const size = cont.querySelector('.fs-toggle-input')?.checked ? '100cm' : '72cm';
        state[type].size = size;
      }
    });
    return state;
  }
  
  function applyState(state) {
    ['bodyShield','faceShield','ultimateSystem'].forEach(type => {
      const cont = document.querySelector(`.solution-container[data-system="${type}"]`);
      if (!cont) return;
  
      // Apply size (where applicable)
      if (type !== 'faceShield' && state?.[type]?.size) {
        const t = cont.querySelector('.fs-toggle-input');
        if (t) t.checked = (state[type].size === '100cm');
      }
  
      // Apply bundle option
      if (state?.[type]?.option) {
        const input = cont.querySelector(`.bundle-size-selector input[value="${state[type].option}"]`);
        if (input) input.checked = true;
      }
  
      // Recompute UI
      const sizeNow = (type !== 'faceShield' && cont.querySelector('.fs-toggle-input')?.checked) ? '100cm' : '72cm';
      const optNow  = cont.querySelector('.bundle-size-selector input:checked')?.value || 'option1';
      if (typeof updateReturningContent === 'function') {
        updateReturningContent(sizeNow, type, optNow);
      }
    });
  
    // Keep Body/Ultimate toggles in sync (your original script mirrors them)
    const bodyT = document.querySelector('.solution-container[data-system="bodyShield"] .fs-toggle-input');
    const ultT  = document.querySelector('.solution-container[data-system="ultimateSystem"] .fs-toggle-input');
    if (bodyT && ultT && bodyT.checked !== ultT.checked) {
      ultT.checked = bodyT.checked;
      const cont = ultT.closest('.solution-container');
      const size = ultT.checked ? '100cm' : '72cm';
      const opt  = cont.querySelector('.bundle-size-selector input:checked')?.value || 'option1';
      if (typeof updateReturningContent === 'function') {
        updateReturningContent(size, 'ultimateSystem', opt);
      }
    }
  }
  
  function persist() {writeState(getCurrentState()); }
})()

